import * as React from 'react';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import PersonAdd from '@mui/icons-material/PersonAdd';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Box": Box, "@mui/material/Avatar": Avatar, "@mui/material/Menu": Menu, "@mui/material/MenuItem": MenuItem, "@mui/material/ListItemIcon": ListItemIcon, "@mui/material/Divider": Divider, "@mui/material/IconButton": IconButton, "@mui/material/Typography": Typography, "@mui/material/Tooltip": Tooltip, "@mui/icons-material/PersonAdd": PersonAdd, "@mui/icons-material/Settings": Settings, "@mui/icons-material/Logout": Logout } } });
export default ClientProvider;
